import React from "react";

import "../../RessourcesStyles/DemandeFormModal.css";
import HorsCatalogue from "./HorsCatalogue";
import HorsCatalogueManager from "./HorsCatalogueManager";
import HorsCatalogueRf from "./HorsCatalogueRf";

const ROLE_CONFIG = {
    APPRENANT: {
        subtitle: "Merci de renseigner les informations de la demande.",
        renderForm: (props) => <HorsCatalogue {...props} />,
    },
    MANAGER: {
        subtitle: "Merci de renseigner les informations de la demande.",
        renderForm: (props) => <HorsCatalogueManager {...props} />,
    },
    RF: {
        subtitle: "Merci de renseigner les informations de la demande.",
        renderForm: (props) => <HorsCatalogueRf {...props} />,
    },
};

export default function DemandeHorsCatalogueModal({
    isOpen,
    onClose,
    campagneId,
    currentUserRole = "APPRENANT",
    loading = false,
}) {
    if (!isOpen) return null;

    const roleConfig = ROLE_CONFIG[currentUserRole] || ROLE_CONFIG.APPRENANT;

    return (
        <div className="demande-modal-overlay" onMouseDown={loading ? undefined : onClose}>
            <div
                className="demande-modal"
                onMouseDown={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="demande-hors-catalogue-title"
            >
                <div className="demande-modal-header">
                    <div className="demande-modal-title" id="demande-hors-catalogue-title">
                        Demande de formation hors catalogue
                    </div>
                    <button
                        className="demande-modal-close"
                        onClick={onClose}
                        type="button"
                        disabled={loading}
                        aria-label="Fermer"
                    >
                        ×
                    </button>
                </div>

                <div className="demande-modal-subtitle">{roleConfig.subtitle}</div>

                {roleConfig.renderForm({
                    campagneId,
                    hideCampagneSelect: true,
                    onCancel: onClose,
                    onSuccess: onClose,
                    loading,
                })}
            </div>
        </div>
    );
}
